import Vue from 'vue';
import App from './App.vue';
import './assets/main.css';
import router from './router';
import { store } from './store/store';
import swal from 'sweetalert2';
import vSelect from 'vue-select';
import PulseLoader from 'vue-spinner/src/ClipLoader';
import AxiosSetUp from './helpers/interceptor';

Vue.component('v-select', vSelect);
Vue.component('pulse-loader', PulseLoader);

Vue.filter('toCurrency', function(value) {
  if (typeof value !== 'number') {
    return value;
  }
  var formatter = new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'IQD',
    minimumFractionDigits: 0,
  });
  return formatter.format(value).replace('IQD', '');
});

Vue.prototype.$http = AxiosSetUp(store);

Vue.config.productionTip = false;

router.beforeEach((to, from, next) => {
  if (to.matched.some((record) => record.meta.requiresAuth)) {
    if (!store.getters.loggedIn) {
      next({
        name: 'login',
      });
    } else {
      next();
    }
  } else if (to.matched.some((record) => record.meta.requiresVisitor)) {
    if (store.getters.loggedIn) {
      next({
        name: 'home',
      });
    } else {
      next();
    }
  } else {
    next();
  }
});

new Vue({
  router,
  store,
  swal,
  render: (h) => h(App),
}).$mount('#app');
